import { triggerNotifications } from '../Helpers/helperMessages';
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from '../constants/Notifications';

export const getAudioPath = (sdkResource, pathAudio, playDuration) => {
    if (!validateUserEntry(pathAudio)) {
        sdkResource.sharedData.audioPathUser = pathAudio;
        sdkResource.sharedData.audioPlayDuration = validateUserEntry(playDuration) === true ? 0 : playDuration;
    }
}

function validateUserEntry(param) {
    return param === undefined || param === null || param === "" || param === "null" || param === "undefined";
}


export const generateAudio = (sdkResource, audioAction, sdkDuration = 0) => {
    const DEFAULT_PLAY_DURATION = 3; 
    const audioPathUser = sdkResource?.sharedData?.audioPathUser || '';
    const isResourceValid = validateUserEntry(audioPathUser);
    const domainAudioPath = `https://${sdkResource?.sharedData?.getDomain()}/IntegrationAgentSDK/audios/${audioAction}.mp3`;

    const createOrReuseAudio = (audioSrc) => {
        let audio = document.getElementById('audio-call-notifications');
        if (!audio) {
            audio = document.createElement('audio');
            audio.id = 'audio-call-notifications';
            audio.className = 'audio';
            audio.autoplay = true;
            audio.volume = 1;
            audio.crossOrigin = 'anonymous';
            document.body.appendChild(audio);
        }
        audio.src = audioSrc;
        return audio;
    };
    const deleteAudioElement = () => {
        const audioElement = document.getElementById('audio-call-notifications');
        if (audioElement) {
            audioElement.remove();
        }
    };

    const playWithLimit = (audio, durationInSeconds) => {
        try {
            audio.play().then(() => {
                setTimeout(() => {
                    audio.pause();
                    deleteAudioElement();
                    triggerNotifications(sdkResource, MESSAGE_CODE.AUDIO_EVENTS[11501], MESSAGE_TYPE.SUCCESS, MESSAGE_FROM.SDK);
                }, durationInSeconds * 1000);
            }).catch(error => {
                console.error(error);
                triggerNotifications(sdkResource, MESSAGE_CODE.AUDIO_EVENTS[11500], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
                deleteAudioElement(); 
            });
        } catch (error) {
            triggerNotifications(sdkResource, MESSAGE_CODE.AUDIO_EVENTS[11500], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
            deleteAudioElement(); 
        }
    };

    const audioSrc = isResourceValid
        ? domainAudioPath
        : `${audioPathUser.endsWith('/') ? audioPathUser : audioPathUser + '/'}${audioAction}.mp3`;

    const audio = createOrReuseAudio(audioSrc);
    audio.onended = deleteAudioElement;
    playWithLimit(audio, sdkDuration || DEFAULT_PLAY_DURATION);
};